import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { cn } from '../lib/utils';
type Props = {
  children: React.ReactNode;
  className?: string;
  href?: string;
  size?: 'md' | 'lg';
};
export const CHECKOUT_URL = 'https://the-realtor-ai-playbook.impultienda.ar/checkout';
export function CTAButton({
  children,
  className = '',
  href = CHECKOUT_URL,
  size = 'lg'
}: Props) {
  const pad = size === 'lg' ? 'min-h-[62px] px-7 py-4 text-[15px] sm:text-base' : 'min-h-[54px] px-6 py-3.5 text-sm sm:text-[15px]';
  return <a href={href} className={cn('group inline-flex w-full max-w-[460px] items-center justify-center gap-2 rounded-xl bg-gold text-center font-display font-extrabold uppercase leading-tight tracking-wide text-navy shadow-[0_12px_32px_-14px_rgba(216,168,78,0.7)] transition-[transform,background-color,box-shadow] duration-200 ease-out hover:-translate-y-0.5 hover:bg-gold-deep focus:outline-none focus-visible:ring-2 focus-visible:ring-cyan focus-visible:ring-offset-2 focus-visible:ring-offset-navy', pad, className)} data-id="element-39" data-mp="2ozi47uuno1zu">
      {children}
      <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-200 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-40" data-mp="1dbjcvbe9r52b" />
    </a>;
}